// @flow
import React, { Fragment } from "react";
import { noop } from "lodash";
import {
  tracks as tracksIcon,
  funnel,
  refresh
} from "@fdr/static-ui/Icons/icons";
import { TracksAZMask } from "@fdr/static-ui/Masks";
import type { NullaryFn } from "@tvg/types/Functional";
import { TracksAZWrapper, Title } from "./styled-components";
import Info from "../../_molecules/Info";

type Track = {
  name: string,
  raceLinks: string[]
};

type Props = {
  templateTitle: string,
  tracks: Track[],
  children: *,
  hasError: boolean,
  onClearFilters: NullaryFn<void>,
  hasActiveFilters: boolean,
  isLoading: boolean
};

const renderEmptyStateMessages = (
  hasError,
  onClearFilters,
  hasActiveFilters
) => {
  let title;
  let messageType;
  let upperIconType = "warning";
  let buttonText = null;
  let icon = refresh;
  if (hasError) {
    title = "Uh Oh!";
    icon = refresh;
    messageType = "There seems to be a problem loading today's tracks";
    upperIconType = "error";
    buttonText = "Refresh";
  } else if (hasActiveFilters) {
    title = "No results";
    icon = funnel;
    messageType = "Your filters have hidden your today's tracks";
    buttonText = "Clear Filters";
  } else {
    icon = tracksIcon;
    title = "No more races available today";
    messageType = "Races should become available in the next minutes";
  }

  return (
    <Info
      icon={icon}
      title={title}
      message={messageType}
      hasUpperIcon
      upperIconType={upperIconType}
      buttonText={buttonText}
      onClearFilters={onClearFilters}
    />
  );
};

const TracksAZ = (props: Props) => (
  <TracksAZWrapper isLoading={props.isLoading}>
    {props.isLoading ? (
      <TracksAZMask />
    ) : (
      <Fragment>
        <Title>{props.templateTitle}</Title>
        {props.children.length
          ? props.children
          : renderEmptyStateMessages(
              props.hasError,
              props.onClearFilters,
              props.hasActiveFilters
            )}
      </Fragment>
    )}
  </TracksAZWrapper>
);

TracksAZ.defaultProps = {
  templateTitle: "Tracks A-Z",
  children: [],
  tracks: [],
  hasError: false,
  onClearFilters: noop,
  hasActiveFilters: false,
  isLoading: false
};

// $FlowFixMe
export default React.memo(TracksAZ);
